// extracted by mini-css-extract-plugin
export default {"container":"LayoutNew_container__aS66U","sub_container":"LayoutNew_sub_container__9-wKX"};